import React from "react";
import styles from "./styles/OutputLegend.module.css";
/**
 * Output window component
 * The back ground color will be set to the color provided, otherwise it will use the default css
 */
const OutputLegend = ({
    color,
    content,
    padding,
    fullWidth,
    background,
    blank,
    inheritCorner,
    stretch,
}) => {
    return (
        <div
            className={`${styles.main_legend_container} ${
                fullWidth ? styles.fullWidth : ""
            }  ${stretch ? styles.stretch : ""} flex-container`}
            style={{
                backgroundColor: color && `${color}${blank ? "" : "1A"}`,
                padding: padding ? padding : 0,
                borderRadius: inheritCorner ? "inherit" : null,
            }}
        >
            {content}
            {background ? (
                <div
                    className={`${styles.background}`}
                    style={{
                        backgroundColor: color && `${color}1A`,
                    }}
                ></div>
            ) : (
                <></>
            )}
        </div>
    );
};

export default OutputLegend;
